import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import '../../../../styles/Login.css';
import { Alert, Box, CircularProgress, Grid, Paper, Snackbar, Typography } from '@mui/material';
import OTPAuth from '@src/components/OTPAuth/OTPAuth';
import TimeRemaining from '../../../../components/Timer/TimeRemaining';
import OTP from '@src/components/OTP/Otp';
import Banner from '@src/assets/images/public-banner.svg';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { useNavigate, useParams } from 'react-router-dom';
import { AxiosError, AxiosResponse } from 'axios';
import { LocalStorage } from '@src/storage/LocalStorage';

const Container = styled.div`
	width: 100%;
	padding: 20px;
	height: 100vh;
	@media screen and (max-width: 600px) {
		padding: 0;
	}
`;

const StyledPaperContainer = styled(Paper)`
	display: flex;
	justify-content: space-between;
	margin: 0 auto;
	flex-direction: column;
	width: 475px;
	height: 85vh;
	background: transparent;
	@media screen and (max-width: 1200px) {
		width: 360px;
	}
`;

const StyledBannerGrid = styled(Grid)`
	@media screen and (max-width: 1200px) {
		display: none;
	}
`;

interface Props {}

const Order: FC<Props> = () => {
	const { apiService }: any = React.useContext(ApplicationContext);
	const { instanceId } = useParams();
	const navigate = useNavigate();

	const countryCode = '+91';
	const [phoneNumber, setPhoneNumber] = useState<string>('');
	const [data, setData] = useState<string>('');
	const [otp, setOtp] = useState<string[]>(['', '', '', '']);
	const [error, setError] = useState<string>('');
	const [otpExpiryTime, setOtpExpiryTime] = useState<number>(-1);
	const [loading, setLoading] = useState(false);
	const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
	const [isErrorVisible, setErrorVisible] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleOTPSubmit = (event: any) => {
		event.preventDefault();
		setLoading(true);
		apiService?.verifyOTPOrderPage(
			{ otp: otp?.join('') },
			(response: AxiosResponse) => {
				const localStorage = new LocalStorage();
				localStorage?.setItem('public-token', response?.data?.data?.token);
				setLoading(false);
				navigate(`/public/order/${instanceId}/details`);
			},
			(error: AxiosError) => {
				setError('Please enter a valid code');
				setLoading(false);
			},
			instanceId
		);
	};

	const handleErrorClose = () => {
		setErrorMessage('');
		setErrorVisible(false);
	};

	const displayError = (msg: string) => {
		setErrorMessage(msg);
		setErrorVisible(true);
	};

	const sendOtp = () => {
		const otpExpiry = new Date().getTime() + 2 * 60 * 1000;
		apiService?.sendOTPOrderPage(
			(response: AxiosResponse) => {
				setData(response?.data?.data);
				setIsPageLoading(false);
				setOtpExpiryTime(otpExpiry);
			},
			(error: AxiosError) => {
				if (error.response && error.response.status === 404) {
					console.log('Error 404: Resource not found');
					navigate(`/404`);
				} else {
					console.log('Error', error);
					displayError('Something went wrong!');
				}
				setIsPageLoading(false);
			},
			instanceId
		);
	};

	useEffect(() => {
		sendOtp();
	}, []);

	if (isPageLoading) {
		return (
			<Box
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<div className="chat__body__loadingMore__wrapper">
					<CircularProgress size={28} />
				</div>
			</Box>
		);
	}

	return (
		<Container className="login-container">
			<Grid container spacing={0} justifyContent="center" alignItems="center">
				<Grid container item xs={12} sm={7} justifyContent="right">
					<StyledPaperContainer elevation={0} style={{ background: 'transparent' }}>
						<OTP
							heading="Order Information"
							content={`Your order #${data} has been received. View the order details by entering the OTP sent to your registered number.`}
							error={error}
							setError={setError}
							setPhoneNumber={setPhoneNumber}
							otp={otp}
							setOtp={setOtp}
							loading={loading}
							otpExpiryTime={otpExpiryTime}
							handleResend={sendOtp}
							setOtpExpiryTime={setOtpExpiryTime}
							handleOTPSubmit={handleOTPSubmit}
						/>
					</StyledPaperContainer>
				</Grid>
				<StyledBannerGrid item xs={12} sm={5}>
					<Grid container justifyContent="center">
						<Grid item>
							<img
								//@ts-ignore
								src={Banner}
								alt="banner"
								style={{ width: '398px', height: '95vh' }}
								loading="lazy"
							/>
						</Grid>
					</Grid>
				</StyledBannerGrid>
			</Grid>
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				open={isErrorVisible}
				autoHideDuration={6000}
				onClose={handleErrorClose}
			>
				<Alert onClose={handleErrorClose} severity="error" elevation={4}>
					{errorMessage}
				</Alert>
			</Snackbar>
		</Container>
	);
};

export default Order;
